import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPagesModule } from './search-pages/search-pages.module';
import { SearchPageCounterPaginationModule } from './search-pages/components/search-page-counter-pagination/search-page-counter-pagination.module';
import { SearchPagesPageNameModule } from './search-pages/components/search-pages-page-name/search-pages-page-name.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, SearchPagesModule, SearchPageCounterPaginationModule, SearchPagesPageNameModule],
  exports: [],
})
export class ContentPagesModule {}
